module.exports = __webpack_public_path__ + "static/template-team-member-1-d72741dac56ee4c504dae2198d198034.jpg";